import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import colorStyles from '@farmers-fridge/ui-library/dist/colors.module.css';
import Tag from '../../../tags/Tag';
import styles from './AppDiscountBanner.module.css';
import AppsDownload from '../../../AppsDownload';

/**
 * @param {object} props
 * @param {string=} props.className
 */
function Spotlight({ className = '' }) {
  return (
    <svg
      className={className}
      width="370"
      height="244"
      viewBox="0 0 370 244"
      xmlns="http://www.w3.org/2000/svg"
      type="presentation"
    >
      <path d="M0.929208 471.742L116.786 -276.34L369.526 -212.421L68.0204 488.71L0.929208 471.742Z" />
    </svg>
  );
}

/**
 * @param {object} props
 * @param {boolean=} props.showFreeMealPromo
 */
export default function AppDiscountBanner({ showFreeMealPromo = false }) {
  return (
    <div className={styles.wrapper}>
      <Spotlight className={styles.spotlightLeft} />
      <Spotlight className={styles.spotlightRight} />
      <div className={styles.bgImageWrapper}>
        <div className={styles.hillsOverImageMask}>
          <StaticImage
            alt="Farmer's Fridge Kiosk"
            aria-hidden="true"
            className={styles.bgImage}
            layout="fullWidth"
            loading="lazy"
            src="../../../../assets/img/promotional_banners/AppDiscountBG.jpg"
          />
        </div>
        <div className={styles.desktopHills} />
      </div>
      <div className={styles.textContent}>
        <Tag
          className={styles.percentOffTag}
          fillColor={colorStyles.color_white_100}
          title="25% off Tag"
          height={76}
          width={203}
        >
          <h3 className={styles.percentOffText}>25% Off</h3>
        </Tag>
        <h4 className={styles.lowPricesText}>Low prices only in the app</h4>
        <svg
          width="238"
          height="8"
          viewBox="0 0 238 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          type="presentation"
        >
          <path
            d="M2 6C2 6 72.8559 2.0191 118.28 2C164.266 1.98066 236 6 236 6"
            stroke={colorStyles.color_half_and_half}
            strokeWidth="4"
            strokeLinecap="round"
          />
        </svg>
      </div>

      <div className={styles.appPromo}>
        <StaticImage
          alt="QR Code to download the Farmer's Fridge App"
          className={styles.appQRCode}
          layout="constrained"
          height={208}
          width={208}
          loading="lazy"
          src="../../../../assets/img/promotional_banners/AppQRCode.png"
        />
        <div className={styles.appPromoText}>
          <p>Download our app and unlock reduced prices at this Fridge</p>
          <AppsDownload className={styles.appDownloadButtons} />
        </div>
      </div>
      <div className={styles.appImage}>
        <StaticImage
          alt="Hand holding a phone with the Farmer's Fridge App"
          aria-hidden="true"
          className={styles.handWithAppImage}
          layout="constrained"
          height={287}
          width={202}
          loading="lazy"
          src="../../../../assets/img/promotional_banners/handHoldingPhoneWithApp.png"
        />
        {showFreeMealPromo && (
          <div className={styles.freeMealPromo}>
            <svg
              className={styles.freeMealBadge}
              viewBox="0 0 175 174"
              xmlns="http://www.w3.org/2000/svg"
              type="presentation"
            >
              <path
                d="M103.207 8.29428L112.875 27.8213L133.694 21.2802L134.567 43.0433L156.252 45.5177L148.18 65.7539L166.982 76.816L151.359 92.0263L164.026 109.763L143.555 117.318L147.898 138.663L126.117 137.255L121.385 158.517L102.061 148.391L89.0711 165.894L75.5455 148.8L56.5446 159.517L51.1557 138.411L29.4292 140.49L33.1089 119.021L12.4135 112.101L24.5255 93.9822L8.43956 79.2609L26.8896 67.6244L18.1946 47.6468L39.7925 44.5049L39.9918 22.7252L61.0031 28.6212L70.0623 8.80541L86.8539 22.7199L103.207 8.29428Z"
                fill={colorStyles.color_green_leaf}
              />
            </svg>
            <div className={styles.freeMealText}>
              <h5 className={styles.freeMealHeader}>First Meal Free</h5>
              <h6 className={styles.freeMealSubheader}>
                when you get the app!
              </h6>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
